import { devtools } from 'zustand/middleware'

import type { StateCreator } from './types'

/**
 * Adds Redux devtools.
 * https://github.com/pmndrs/zustand#redux-devtools
 */
export function addDevtool(creator: StateCreator, name: string): StateCreator {
  return devtools(creator, {
    name: `FWN Widget (${name})`,
  }) as StateCreator
}
